import { defaultErrorCallback } from '@chilipiper/service/src/api'
import { get } from '@chilipiper/service/src/api-v2'
import { SingleUseLink } from '@chilipiper/api-type-def/src/bookingLinks'
import { useEffect, useState } from 'react'
import { getDomain } from '@chilipiper/utils'

export const useExchangeSingleUseLink = (id?: string) => {
  const [data, setData] = useState<SingleUseLink>()
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    const domain = getDomain()
    if (!id || !domain) {
      return
    }
    setLoading(true)
    get(`bookinglinks/singleuse/${domain}/${id}`)
      .json<SingleUseLink>()
      .then(result => {
        setData(result)
      })
      .catch(defaultErrorCallback)
      .finally(() => setLoading(false))
  }, [])
  return {
    data,
    isLoading: loading,
  }
}
